import React from "react";
import images from "../../assets/images";
import "./style.css";

const Hero = () => {
  const backgroundImage = `url(${images.hero.hero})`;

  return (
    <section id="hero" style={{ backgroundImage }}>
      <div className="hero-overlay" />

      <div className="hero-container" data-aos="fade-in" data-aos-duration="1800">
        <p className="hero-monogram">L &amp; M</p>
        <div className="hero-rule"></div>
        <h1 className="hero-names">Lucero &amp; Miguel</h1>
        <div className="hero-rule"></div>
        <p className="hero-date">19 · Septiembre · 2026</p>
        <p className="hero-location">Tlajomulco de Zúñiga, Jal.</p>
      </div>

      <div className="hero-scroll-indicator">
        <span></span>
      </div>
    </section>
  );
};

export default Hero;
